import { SECTION_MANIFEST, SECTION_ROLES, type SectionRole } from "./section-manifest";

export { SECTION_ROLES, type SectionRole };

export const UNKNOWN_SECTION_ROLE = "unknown";

export const SECTION_TYPE_ROLES = Object.fromEntries(
  Object.entries(SECTION_MANIFEST).map(([type, def]) => [type, def.role]),
) as Record<string, SectionRole>;

export function roleForSectionType(type: string): SectionRole | typeof UNKNOWN_SECTION_ROLE {
  return SECTION_TYPE_ROLES[type] ?? UNKNOWN_SECTION_ROLE;
}
